import { useEffect, useState } from 'react';

import { loadCapabilityCatalog, peekCapabilityCatalog, type CapabilityCatalog } from '../../../engine/scripting/monaco/capabilityCatalog';

/** The native capability catalog for a render: `undefined` until the
 * tooling wasm has loaded and the catalog is built (a few milliseconds
 * after the first request; later mounts get it immediately). */
export function useCapabilityCatalog(): CapabilityCatalog | undefined {
  const [catalog, setCatalog] = useState<CapabilityCatalog | undefined>(peekCapabilityCatalog);
  useEffect(() => {
    if (catalog) return;
    let cancelled = false;
    loadCapabilityCatalog().then(
      (loaded) => {
        if (!cancelled) setCatalog(loaded);
      },
      () => undefined,
    );
    return () => {
      cancelled = true;
    };
  }, [catalog]);
  return catalog;
}
